<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Chuyên cần
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card outlined class="ma-6 elevation-0">
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="id"
          :loading="loading"
          loading-text="Đang Tải"
          mobile-breakpoint="0"
          items-per-page="5"
          disable-sort
          no-data-text="Không có dữ liệu"
          :footer-props="{
            'items-per-page-text': 'Số dòng mỗi trang',
          }"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-chip small label :color="item.status | getAttendanceStatusColor" dark>
              <span>
                {{ item.status | getAttendanceStatus }}
              </span>
            </v-chip>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ convertDate(item.date) }}
          </template>
        </v-data-table>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {},
  data() {
    return {
      dialog: false,
      loading: false,
      items: [],
      headers: [
        {
          text: 'Buổi ngày',
          value: 'date',
          align: 'left',
          sortable: true,
          show: true,
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'center',
          sortable: true,
          show: true,
        },
      ],
    }
  },
  methods: {
    ...mapActions('lessonAttendance', ['fetchAttendances']),
    async openDialog(item) {
      this.items = []
      this.loading = true
      this.dialog = true
      this.items = await this.fetchAttendances({ class: item.class.id, student: item.student.id })
      this.loading = false
    },
    cancel() {
      this.dialog = false
    },
    convertDate(date) {
      return this.$moment(date).format('DD/MM/YYYY')
    },
  },
}
</script>
